<template>
  <v-footer app absolute padless max-width="450px"  height="60px"
    style="box-sizing: border-box; background-color: #329331;"
    class="footer-buttons justify-space-around"
  >
    <div v-for="link in links" :key="link.name" 
      :class="{ current_tab: currentPath(link) }"
      class="mx-2 flex-grow-1 py-2"
    >
      <router-link :to="{ name: link.name }"
        :active="currentPath(link)"
        class="d-flex flex-column align-center justify-center text-decoration-none white--text"
      >
        <v-icon :color="currentPath(link) ? 'white' : 'white'">{{ link.icon }}</v-icon>
        <div style="font-size: 10px; line-height: 10px;">{{ link.label }}</div>
      </router-link>
    </div>
  </v-footer>
</template>

<script>
export default {
  name: "NavFooter",

  data: () => ({
    links: [
      { label: 'Leads', name: 'home', path: '/home', icon: 'mdi-home-outline'},
      { label: 'Reports', name: 'reports', path: '/reports', icon: 'mdi-chart-line'},
      { label: 'Billing', name: 'billing/account', path: '/billing', icon: 'mdi-credit-card-check-outline'},
      { label: 'You', name: 'you/menu', path: '/you', icon: 'mdi-account-box-outline'},
    ],
  }),

  methods: {
    currentPath: function (link) { 
      return this.$route.matched.some( r => r.path == link.path )
    },
  }
}
</script>

<style lang="scss" scoped>

.footer-buttons {
  .current_tab {
    border-bottom: 3px solid white;
  }
}

</style>